var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_151_125277",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_151_125277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 28C17.3778 28 15.0444 27.2556 13 25.7667C10.9556 24.2778 9.51111 22.3556 8.66667 20H4V17.3333H8.06667C8 16.8 7.97222 16.3056 7.98333 15.85C7.99444 15.3944 8.02222 15 8.06667 14.6667H4V12H8.66667C9.51111 9.64444 10.9556 7.72222 13 6.23333C15.0444 4.74444 17.3778 4 20 4C21.5333 4 22.9833 4.27222 24.35 4.81667C25.7167 5.36111 26.9333 6.11111 28 7.06667L26.1 8.93333C25.2778 8.22222 24.35 7.66667 23.3167 7.26667C22.2833 6.86667 21.1778 6.66667 20 6.66667C18.1111 6.66667 16.4222 7.16111 14.9333 8.15C13.4444 9.13889 12.3222 10.4222 11.5667 12H20V14.6667H10.7667C10.6778 15.2667 10.6444 15.7944 10.6667 16.25C10.6889 16.7056 10.7222 17.0667 10.7667 17.3333H20V20H11.5667C12.3222 21.5778 13.4444 22.8611 14.9333 23.85C16.4222 24.8389 18.1111 25.3333 20 25.3333C21.1778 25.3333 22.2833 25.1333 23.3167 24.7333C24.35 24.3333 25.2778 23.7778 26.1 23.0667L28 24.9333C26.9333 25.8889 25.7167 26.6389 24.35 27.1833C22.9833 27.7278 21.5333 28 20 28Z",
    fill: "#A1A1A1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFine);
export default __webpack_public_path__ + "static/media/Fine.a24f73ca182a2cdcc9a835caaeb2d5af.svg";
export { ForwardRef as ReactComponent };